import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'

import { payload } from '@bldsoft/cappie/rest'
import { formatContinueWatching } from './continueWatching.format'

export function use(
  client: WbsClient,
  continueWatching: API['continueWatching'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  continueWatching.getContinueWatchingFx.use(async (args) => {
    const page = await payload(
      client.get.api.v3.continueWatching({ query: { ...args } })
    )
    return formatContinueWatching(page)
  })
}
